import { find, includes, map } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import ReactCollapse from 'react-collapse';

import { LocaleService } from '@sm360/widget-commons-core-services';

import MetaDataModel from 'inventory-listing/models/MetaDataModel.js';
import VehicleCriteriaModel from 'inventory-listing/models/VehicleCriteriaModel.js';
import Models from 'inventory-listing/components/ListingFilters/Components/ListingFiltersBrand/Models.jsx';

import 'inventory-listing/components/ListingFilters/Components/ListingFiltersBrand/ListingFiltersBrand.scss';
import 'inventory-listing/components/ListingFilters/Components/ListingFiltersBrand/Brands.scss';

class ListingFiltersBrand extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            makeIsOpen: false,
            modelIsOpen: false,
        };

        this.handleMakeSelection = this.handleMakeSelection.bind(this);
        this.handleAllBrands = this.handleAllBrands.bind(this);
        this.toggleMakeCollapsable = this.toggleMakeCollapsable.bind(this);
        this.handleModel = this.handleModel.bind(this);
        this.renderMakes = this.renderMakes.bind(this);
        this.renderModels = this.renderModels.bind(this);
        this.setMakeInUrl = this.setMakeInUrl.bind(this);
    }

    get currentMake() {
        const { makes, vehicleCriteria } = this.props;
        return find(makes, (make) => includes(vehicleCriteria.makeIds, make.get('code')));
    }

    /**
     * Automatically set the url with a make.
     * Should be called only if there is one make available.
     *
     * @param {*} metadatas (should be called from Models component) with a list of models.
     * @param {*} attribute (should be called from Models component) with modelIds.
     */
    setMakeInUrl(metadatas, attribute) {
        this.setState((prevState) => {
            const updatedMakes = [...prevState.makes];
            updatedMakes[0] = updatedMakes[0].set('isSelected', true);
            this.props.updateVehicleCriteria(updatedMakes, 'makeIds');
        }, this.props.updateVehicleCriteria(metadatas, attribute));
    }

    handleMakeSelection(e, id) {
        e.preventDefault();

        const makes = map(this.props.makes, (make) => {
            return make.set('isSelected', make.get('code') === id);
        });
        this.setState({ modelIsOpen: true });
        this.props.updateVehicleCriteria(makes, 'makeIds');
    }

    toggleMakeCollapsable() {
        this.setState((prevState) => {
            return { makeIsOpen: !prevState.makeIsOpen };
        });
    }

    handleModel() {
        this.setState((prevState) => {
            return { modelIsOpen: !prevState.modelIsOpen };
        });
    }

    handleAllBrands(evt) {
        evt.preventDefault();
        this.handleMakeSelection(evt, 'none');
        this.setState({ modelIsOpen: false });
        this.props.updateVehicleCriteria([], 'modelIds');
    }

    renderMakes() {
        const { makes } = this.props;
        const openMake = this.currentMake;

        return !openMake ? (
            makes.map((make) => (
                <div className="listing-used-brands" key={make.code}>
                    <div className="brand-list close">
                        <button className="brand-label" onClick={(e) => this.handleMakeSelection(e, make.code)}>
                            {make.label}
                        </button>
                    </div>
                </div>
            ))
        ) : (
            <div className="listing-used-brands" key={openMake.code}>
                <div>
                    <button className="all-brands is-util" onClick={(e) => this.handleAllBrands(e)}>
                        {LocaleService.t('FILTERS.ALL_MAKES')}
                    </button>
                </div>
                <div className="brand-list open is-price">
                    <button className="brand-label" onClick={(e) => this.handleMakeSelection(e, openMake.code)}>
                        {openMake.label}
                    </button>
                </div>
            </div>
        );
    }

    renderModels(currentMake) {
        const { vehicleCriteria } = this.props;

        return (
            currentMake && (
                <Models
                    makeCode={currentMake.code}
                    isMakeSelected
                    updateVehicleCriteria={(metadatas, attribute) => {
                        if (this.props.makes.length === 1) {
                            this.setMakeInUrl(metadatas, attribute);
                        } else {
                            this.props.updateVehicleCriteria(metadatas, attribute);
                        }
                    }}
                    selectedModels={vehicleCriteria.modelIds}
                />
            )
        );
    }

    render() {
        const { makes } = this.props;
        const brandList = this.renderMakes();

        const makeClass = this.state.makeIsOpen
            ? 'listing-used-filters-bloc listing-used-filters-brand isOpen'
            : 'listing-used-filters-bloc listing-used-filters-brand';

        const makeList = makes.length > 1 && (
            <div className={makeClass}>
                <button className="listing-used-filters-title is-bold" onClick={this.toggleMakeCollapsable}>
                    {LocaleService.t('FILTERS.MAKES')}
                    <icon className="icon-Arrow-Menu-Top" />
                </button>
                <ReactCollapse isOpened={this.state.makeIsOpen}>
                    <ul className="listing-used-brands-container">
                        <li className="brands-list">{brandList}</li>
                    </ul>
                </ReactCollapse>
            </div>
        );
        let { currentMake } = this;
        if (makes.length === 1) {
            currentMake = {
                code: makes[0].get('code'),
                isSelected: true,
            };
        }

        const modelList = this.renderModels(currentMake);

        const modelClass = ['listing-used-filters-bloc', 'listing-used-filters-model'];
        let collapseModel = true;
        if (currentMake && currentMake !== null) {
            modelClass.push('isAvailable');
            collapseModel = this.state.modelIsOpen;
        }
        if (currentMake && currentMake !== null && this.state.modelIsOpen) {
            modelClass.push('isOpen');
        }

        return (
            <div className="listing-used-filters-bloc-make">
                {makeList}
                <div className={modelClass.join(' ')}>
                    <button className="listing-used-filters-title is-bold" onClick={this.handleModel}>
                        {LocaleService.t('FILTERS.MODELS')}
                        <icon className="icon-Arrow-Menu-Top" />
                    </button>
                    <ReactCollapse isOpened={collapseModel}>{modelList}</ReactCollapse>
                </div>
            </div>
        );
    }
}

ListingFiltersBrand.defaultProps = {
    makes: [],
};

ListingFiltersBrand.propTypes = {
    makes: PropTypes.arrayOf(PropTypes.instanceOf(MetaDataModel)),
    updateVehicleCriteria: PropTypes.func.isRequired,
    vehicleCriteria: PropTypes.instanceOf(VehicleCriteriaModel).isRequired,
};

ListingFiltersBrand.displayName = 'ListingFiltersBrand';

export default ListingFiltersBrand;



// WEBPACK FOOTER //
// ./client/src/components/ListingFilters/Components/ListingFiltersBrand/ListingFiltersBrand.jsx